import React from 'react';
import { HexColorInput, HexAlphaColorPicker } from 'react-colorful';
import toggleColorPicker from '../../../Functions/toggleColorPicker';

const Container = ({ widget, handleInputChange, setColorsAndPreview }) => {
  const { monthlypayment } = widget.htmlData;

  const handleNumberChange = (e, field) => {
    const value = parseFloat(e.target.value);
    if (!isNaN(value)) {
      handleInputChange({
        target: {
          name: `container-${field}`,  // Modified to use section-field format
          value: `${value}px`
        }
      });
    }
  };

  return (
    <div className="mjwi-acc-panel-wrapper">
      <div className="mjwi-row">
        <div className="mjwi-col66">
          <label>Background Color</label>
        </div>
        <div className="mjwi-col66 mjwi-clr-picker">
          <span
            className="clrPickerVal"
            style={{ backgroundColor: monthlypayment.container.bgColor }}
            onClick={toggleColorPicker}
          ></span>
          <HexAlphaColorPicker
            color={monthlypayment.container.bgColor}
            onChange={(color) => setColorsAndPreview('container', 'bgColor', color)}
            className="mjwi-apfl-color-picker"
          />
          <HexColorInput
            color={monthlypayment.container.bgColor}
            onChange={(color) => setColorsAndPreview('container', 'bgColor', color)}
          />
        </div>
      </div>
      <div className="mjwi-row">
        <div className="mjwi-col66">
          <label>Border Color</label>
        </div>
        <div className="mjwi-col66 mjwi-clr-picker">
          <span
            className="clrPickerVal"
            style={{ backgroundColor: monthlypayment.container.borderColor }}
            onClick={toggleColorPicker}
          ></span>
          <HexAlphaColorPicker
            color={monthlypayment.container.borderColor}
            onChange={(color) => setColorsAndPreview('container', 'borderColor', color)}
            className="mjwi-apfl-color-picker"
          />
          <HexColorInput
            color={monthlypayment.container.borderColor}
            onChange={(color) => setColorsAndPreview('container', 'borderColor', color)}
          />
        </div>
      </div>
      <div className="mjwi-row">
        <div className="mjwi-col66">
          <label>Border Radius</label>
        </div>
        <div className="mjwi-col33">
          <input
            type="number"
            name="borderRadius"
            value={parseFloat(monthlypayment.container.borderRadius) || 0}
            onChange={(e) => handleNumberChange(e, 'borderRadius', ['container'])}
            className="mjwi-input"
            min="0"
          />
        </div>
      </div>
      <div className="mjwi-row">
        <div className="mjwi-col66">
          <label>Padding</label>
        </div>
        <div className="mjwi-col33">
          <input
            type="number"
            name="padding"
            value={parseFloat(monthlypayment.container.padding) || 0}
            onChange={(e) => handleNumberChange(e, 'padding', ['container'])}
            className="mjwi-input"
            min="0"
          />
        </div>
      </div>
    </div>
  );
};

export default Container;